
export default [
  
  {
    title: 'Dashboard',
    name: 'dashboard',
    route: 'dashboard',
    icon: 'HomeIcon',
    meta: {
      module: 'dashboard'
    }
  },

  {
    title:  'Main menu',
    icon: 'SettingsIcon',
    name: 'dashboard',
    tagVariant: 'light-warning',
  
    isOpen:true,
    isActive:true,
    children: [
      
      {
         
        title: 'Roles',
        name: 'roles.list',
        route: 'roles.list',
        icon: 'KeyIcon',
        meta: {
          
          module: 'roles'
        }
      },
    
      {
        title: 'Privileges',
        name: 'permissions',
        route: 'permissions',
        icon: 'KeyIcon',
        meta: {
          module: 'permissions'
        }
      },
  {
    title: 'Users',
    name: 'users.list',
    route: 'users.list',
    icon: 'UserIcon',
    meta: {
      module: 'users'
    }
  },


  {
    title: 'Devices',
    name: 'devices.list',
    route: 'devices.list',
    icon: 'TruckIcon',
    meta: {
      module: 'devices'
    }
  },
  {
    title: 'Maintenances',
    name: 'maintenances.list',
    route: 'maintenances.list',
    icon: 'ToolIcon',
    meta: {
      module: 'maintenances'
    }
  },
  {
    title: 'Containers',
    name: 'containers.list',
    route: 'containers.list',
    icon: 'TrashIcon',
    meta: {
      module: 'containers'
    }
  },


  {
    title: 'Rfid Devices',
    name: 'rfids.list',
    route: 'rfids.list',
    icon: 'CpuIcon',
    meta: {
      module: 'rfids'
    }
  },


  {
    title: 'Drivers',
    name: 'drivers.list',
    route: 'drivers.list',
    icon: 'LifeBuoyIcon',
    meta: {
      module: 'drivers'
    }
  },


  {
    title: 'Geofence',
    name: 'geofence.list',
    route: 'geofence.list',
    icon: 'GlobeIcon',
    meta: {
      module: 'geofence'
    }
  },


  {
    title: 'Types',
    name: 'types.list',
    route: 'types.list',
    icon: 'CopyIcon',
    meta: {
      module: 'types'
    }
  },

  {
    title: 'Contracts',
    name: 'contracts.list',
    route: 'contracts.list',
    icon: 'FileIcon',
    meta: {
      module: 'contracts'
    }
  },

  {
    title: 'Work Shifts',
    name: 'workShifts.list',
    route: 'workShifts.list',
    icon: 'FileIcon',
    meta: {
      module: 'workShifts'
    }
  },

  {
    title: 'Groups',
    name: 'groups.list',
    route: 'groups.list',
    icon: 'GridIcon',
    meta: {
      module: 'groups'
    }
  },

  {
    title: 'Alerts',
    name: 'alerts.list',
    route: 'alerts.list',
    icon: 'BellIcon',
    meta: {
      module: 'alerts'
    }
  },

    ]
  }
]
